import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';

const GetAllMessages = gql`
query Messages($senderName: String!, $toName: String!, $limitNum: Int!) {
  messages(name: $senderName, to: $toName, limit: $limitNum) {
      _id
      createdAt
      updatedAt
      user_id
      socket_id
      msg
  }
}
`;
const GetMessagesByUser = gql`
query MessagesByUser($userId: String, $toId: String, $limitNum: Int) {
  messagesByUser(user_id: $userId, to_id: $toId, limit: $limitNum) {
      _id
      createdAt
      updatedAt
      user_id
      name
      to
      to_id
      socket_id
      msg
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private apollo: Apollo) { }
  
  getAllMessages(userName: string, toUserName: string, limit){
    return this.apollo.query({
      query: GetAllMessages,
      variables: { senderName: userName, toName: toUserName, limitNum: limit}
    })
  }
  
  getUserMessages(uId: string, toUserId: string, limit: number){
    return this.apollo.query({
      query: GetMessagesByUser,
      variables: {userId: uId, toId: toUserId, limitNum: limit}
    })
  }
}
